import axios from "axios";
import { AUTH_URL, BASE_URL } from "../util/constants";
import TokenResponse from "../interfaces/tokenResponse";
import UserLogin from "../interfaces/userLogin";
import UserRegister from "../interfaces/userRegister";

const useApiAuth = () => {
    const axiosInstance = axios.create({
        baseURL: BASE_URL,
    });

    const login = (user: UserLogin) => {
        return axiosInstance
            .post<TokenResponse>(AUTH_URL + "/login", user)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const register = (user: UserRegister) => {
        return axiosInstance
            .post<TokenResponse>(AUTH_URL + "/register", user)
            .then((rest) => rest.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const tokenLogin = (token: string) => {
        return axiosInstance
            .post<TokenResponse>(`${AUTH_URL}/token/${token}`)
            .then((res) => res.data)
            .catch((err) => {
                handleError(err);
                throw err;
            });
    }

    const handleError = (err: any) => {
        console.log("Error occurred: ", err);

        if(err.response) {
            console.log("Response: ", err.response.data);
            console.log("Status: ", err.response.status);
        } else if(err.request && err.config) {
            console.log("URL: ", err.config.baseURL);
            console.log("Method: ", err.config.method);
            console.log("URL requested: ", err.config.url);
        } else {
            console.log("Error message: ", err.message);
        }
    }

    return { login, tokenLogin, register };
}

export default useApiAuth;